export default "__VITE_ASSET__BTHwRyyL__"